import { ReactNode } from "react";

type Tone = "amber" | "blue" | "green";

interface NoticeProps {
  tone?: Tone;
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
}

const TONES: Record<Tone, { bg: string; border: string; iconBg: string; t: string; b: string }> = {
  amber: { bg: "#FEF3C7", border: "#FDE68A", iconBg: "#F59E0B", t: "#92400E", b: "#B45309" },
  blue: { bg: "#EFF6FF", border: "#BFDBFE", iconBg: "#2196f3", t: "#1565C0", b: "#1976D2" },
  green: { bg: "#DCFCE7", border: "#BBF7D0", iconBg: "#10B981", t: "#166534", b: "#15803D" },
};

const Notice = ({ tone = "amber", icon, title, children }: NoticeProps) => {
  const c = TONES[tone];
  return (
    <div
      className="flex gap-[13px] items-start rounded-[14px] px-4 py-[14px]"
      style={{ background: c.bg, border: `1px solid ${c.border}` }}
    >
      <div
        className="w-[38px] h-[38px] rounded-[10px] flex items-center justify-center shrink-0 text-white"
        style={{ background: c.iconBg }}
      >
        {icon}
      </div>
      <div className="flex-1 min-w-0">
        {title && <div className="text-sm font-extrabold mb-[3px]" style={{ color: c.t }}>{title}</div>}
        <div className="text-[12.5px] leading-[1.65]" style={{ color: c.b }}>{children}</div>
      </div>
    </div>
  );
};

export default Notice;
